import React from 'react';
import Button from './Button';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        console.error("Funnel Error:", error, errorInfo);
        // Optionally log to analytics/sentry
    }

    handleReset = () => {
        console.warn('Recovering from crash: Clearing all state...');
        sessionStorage.clear();
        localStorage.clear(); // Extra precaution
        this.setState({ hasError: false });
        window.location.href = '/'; // Go back to start
    };

    render() {
        if (this.state.hasError) {
            return (
                <div className="min-h-screen flex items-center justify-center bg-secondary-100 p-6">
                    <div className="bg-white p-8 rounded-2xl shadow-xl max-w-md text-center">
                        <div className="text-4xl mb-4">⚠️</div>
                        <h1 className="text-h2 text-primary-70 mb-2">Oops, something went wrong</h1>
                        <p className="text-body text-gray-500 mb-6">
                            We encountered an unexpected error. Please try refreshing the page.
                        </p>
                        <Button onClick={this.handleReset} fullWidth>
                            Refresh Page
                        </Button>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
